import template from './messagesList.template.html';

export default {
  template,
  bindings: {
    messages: '<',
    labels: '<',
    onClick: '&',
    onLabelsSelect: '&',
    onChange: '&',
    onReady: '&'
  },
  controller: class controller {
    constructor($rootScope, $filter, $mdMedia, listServiceNew) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.list.setData(
          $filter('stStartingLetter')(ctrl.messages, ctrl.list.getGroupingByFirstLetter())
        );
        ctrl.onReady({ list: ctrl.list });
      };

      ctrl.click = ($event, data) => {
        ctrl.onClick({ event: $event, data });
      };

      ctrl.select = (data) => {
        const isSelected = ctrl.list.setSelected(data);
        ctrl.onChange({ list: ctrl.list, data, isSelected });
      };

      ctrl.labelsSelect = ($event, data) => {
        ctrl.onLabelsSelect({ event: $event, data });
      };

      ctrl.getLabel = (idLabel) => _.find(ctrl.labels, (label) => label.id === idLabel);

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = (changes) => {
        if (
          (changes.messages && changes.messages.currentValue) ||
          (changes.labels && changes.labels.currentValue)
        ) {
          ctrl.initialize();
        }
      };
    }
  }
};
